module.exports = __webpack_public_path__ + "media/assets/images/category/MothersDay@2x-e8d766ff0493bdb8eb9b4a72aa240415.png";